import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import ViewTaskDetails from '../../modules/admin/components/TaskOrRequest/ViewTaskDetails';

const TaskDetails = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('admin->>TaskDetails.ViewDetails')} />

      <ViewTaskDetails />
    </>
  );
};

export default TaskDetails;
